import React from "react";
import { useEffect,useState } from "react";
import { Link, useNavigate ,useOutletContext} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import MembFindIdRsltUi from "./MembFindIdRsltUi";
import MbpAthnUi from "Utils/MbpAthn";
import EmlAthnModalUi from "Utils/EmlAthnModalUi";
import MgpStore from "Stores/Store";
import MbpAthnRsltVrfRqstApi from "Apis/MbpAthnRsltVrfRqstApi";
import"Assets/css/MembFind.css";
import UseLangLstQuery from "Apis/LangTxtInqApi";

const MembFindIdUi = () => {
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const navigate = useNavigate();
    var popupX = Math.round(window.screenX + (window.outerWidth/2) - (500/2));
    var popupY = Math.round(window.screenY + (window.outerHeight/2) - (800/2));
    const [emlAthnPrpsCd] =useState("MEMB_FIND");
    const [showEmlModal, setShowEmlModal] = useState(false);
    const [identMthCdState,setIdentMthCdState] =useState("");
    const isMobile = window.innerWidth <= 1024;
    const EmlAthnPopFunc = (e:any)=>{
        if (isMobile) {
            setShowEmlModal(true);
        } else {
            window.open(e,"_blank","width=550,height=800 left="+popupX+"top="+popupY);
        }
    }
    useEffect(()=> {
        function kmcRespFunc (kmcApiTknrslt:string,kmcApiCertNumrslt:string){
            MbpAthnRsltVrfRqstApi(kmcApiTknrslt,kmcApiCertNumrslt)
            .then((resp) => {
                return navigate("/MembFindId/List",{state:{idntMthdCd:"MBP"}});
            }).then((resp)=> {
            });
        }
        window.kmcRespFunc = kmcRespFunc;
        window.emlAthnRespFunc = () => {
            return navigate("/MembFindId/List",{state:{idntMthdCd:"EML"}});
        };
    },[])
    return(
        <div className="loginInputWrap">
            <Helmet>
                <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MEMB_FIND_ID_MAIN_TITL_00}`}</title>
            </Helmet>
            <Link to="/Login" className='loginBackBtn'>
                <img src={process.env.PUBLIC_URL + '/images/login/backIcon.png'} alt="" />
            </Link>
            <div className="membJoinForm">
                <div className="membFindTitl">
                    {/* <img className="membFindPwImg" src={process.env.PUBLIC_URL+ "/images/Find/FindID.png"} alt="" /> */}
                    <h1>{langData&&langData.MEMB_FIND_ID_MAIN_TITL_00}</h1>
                    {/* 아이디 찾기 */}
                    <p>{langData&&langData.MEMB_FIND_ID_MAIN_DESC_00}</p>
                    {/* 아이디 찾기를 위해 원하시는 본인확인 방식을 선택해 주세요. */}
                </div>
                <div className="athnWrap">
                    <ul>
                        <li className="athnLi">
                            <p className="athnTitl">{langData&&langData.MEMB_FIND_PASSWD_MBP_LBL_00}</p>
                            {/* 휴대폰 인증 */}
                            <div className="athnImgWrap">
                                <img src={process.env.PUBLIC_URL + "/images/Athn/AthnMo.png"} alt="" />
                            </div>
                            <MbpAthnUi athnPrpsCd={"MEMB_FIND"} BtnClass="loginBtn" AthnTxt={langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00}/>
                        </li>
                        <li className="athnLi">
                            <p className="athnTitl">{langData&&langData.MEMB_FIND_PASSWD_EML_LBL_00}</p>
                            {/* 이메일 인증 */}
                            <div className="athnImgWrap">
                                <img src={process.env.PUBLIC_URL + "/images/Athn/AthnEml.png"} alt="" />
                            </div>
                            <button onClick={() => EmlAthnPopFunc(`${'/EmlAthnPop?emlAthnPrpsCd=' + emlAthnPrpsCd + "&lang=" +MgpStore.getState().LangSetState.Lang}`)} className="loginBtn">
                                <p>{langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00}</p>
                                {/* 인증하기 */}
                            </button>
                            {showEmlModal && (
                                
                                        <EmlAthnModalUi
                                            emlAthnPrpsCd={emlAthnPrpsCd}
                                            onSuccess={() => {
                                                setShowEmlModal(false);
                                                if (typeof window.emlAthnRespFunc === 'function') {
                                                    window.emlAthnRespFunc();
                                                }
                                            }}
                                            onClose={() => setShowEmlModal(false)}
                                        />
                            )}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default MembFindIdUi;